/* HOA cart drawer recommendations
   Layer 2: suggest in-stock products from related product types only (rules below)
   Layer 3: if nothing matches, show nothing */
(function () {
  var RULES = {
    'vacuum cleaners': ['Cleaning Accessories', 'Cleaning Tools', 'Purifiers'],
    'cleaning accessories': ['Cleaning Tools'],
    'coffee makers': ['Coffee & Spice Grinders', 'Milk Frothers', 'Coffee & Tea Cups'],
    'coffee & spice grinders': ['Milk Frothers', 'Coffee & Tea Cups'],
    'milk frothers': ['Coffee & Tea Cups', 'Coffee & Spice Grinders'],
    'tea makers': ['Coffee & Tea Cups', 'Coffee & Tea Service'],
    'air fryer': ['Electric Grills', 'Sandwich Makers & Grills', 'Food Steamers', 'Rice Cookers'],
    'air fryers': ['Electric Grills', 'Sandwich Makers & Grills', 'Food Steamers', 'Rice Cookers'],
    'cookware': ['Kitchen Utensils', 'Utensil Sets', 'Knives', 'Chopping Boards', 'Chopping Board'],
    'pressure cookers': ['Air Fryers', 'Rice Cookers', 'Food Steamers'],
    'pressure cookers & multi cookers': ['Air Fryers', 'Rice Cookers', 'Food Steamers'],
    'rice cooker': ['Food Steamers', 'Pressure Cookers & Multi Cookers', 'Air Fryers'],
    'rice cookers': ['Food Steamers', 'Pressure Cookers & Multi Cookers', 'Air Fryers'],
    'knives': ['Chopping Boards', 'Chopping Board', 'Kitchen Utensils'],
    'chopping boards': ['Knives', 'Kitchen Utensils'],
    'chopping board': ['Knives', 'Kitchen Utensils'],
    'kitchen utensils': ['Kitchen Gadgets', 'Utensil Sets', 'Knives'],
    'utensil sets': ['Knives', 'Chopping Boards'],
    'kitchen gadgets': ['Kitchen Utensils', 'Food Storage'],
    'toasters': ['Electric Kettles'],
    'electric kettles': ['Toasters', 'Coffee & Tea Cups'],
    'blenders': ['Juicers', 'Hand Blenders', 'Food Processors'],
    'blenders & juicers': ['Hand Blenders', 'Food Processors', 'Juicers'],
    'juicers': ['Blenders', 'Hand Blenders', 'Food Processors'],
    'hand blenders': ['Hand Mixers', 'Food Processors', 'Kitchen Scales'],
    'hand mixers': ['Hand Blenders', 'Food Processors', 'Kitchen Scales'],
    'stand mixers': ['Hand Blenders', 'Food Processors', 'Kitchen Scales'],
    'mixers': ['Hand Blenders', 'Food Processors', 'Kitchen Scales'],
    'food processors': ['Hand Blenders', 'Blenders', 'Kitchen Scales'],
    'bakeware': ['Kitchen Scales', 'Kitchen Utensils'],
    'microwaves': ['Electric Kettles', 'Toasters'],
    'electric ovens': ['Air Fryers', 'Electric Grills', 'Toasters'],
    'sandwich makers': ['Toasters', 'Waffle & Crepe Makers', 'Electric Grills'],
    'sandwich makers & grills': ['Toasters', 'Waffle & Crepe Makers', 'Electric Grills'],
    'electric grills': ['Sandwich Makers & Grills', 'Air Fryers', 'Toasters'],
    'irons & steamers': ['Ironing Boards', 'Laundry Baskets'],
    'ironing boards': ['Irons & Steamers'],
    'trimmers & clippers': ['Electric Shavers', 'Electric Toothbrush'],
    'electric shavers': ['Trimmers & Clippers', 'Electric Toothbrush'],
    'grooming': ['Electric Shavers', 'Electric Toothbrush'],
    'hair removal': ['Skin & Facial Care', 'Hair Stylers & Curlers'],
    'hair dryers': ['Hair Straighteners', 'Hair Stylers & Curlers', 'Curling Irons'],
    'hair straighteners': ['Hair Dryers', 'Hair Stylers & Curlers'],
    'hair stylers & curlers': ['Hair Dryers', 'Hair Straighteners'],
    'curling irons': ['Hair Dryers', 'Hair Straighteners'],
    'waste bins': ['Cleaning Tools', 'Home Organisation'],
    'dish racks': ['Kitchen Utensils', 'Cleaning Tools'],
    'bathroom accessories': ['Towels & Textiles'],
    'drinkware': ['Serveware', 'Tableware'],
    'tableware': ['Serveware', 'Drinkware'],
    'serveware': ['Tableware', 'Drinkware']
  };
  /* Small appliances where the same brand should be suggested first (e.g. Smeg toaster -> Smeg kettle) */
  var SAME_BRAND_FIRST = ['toasters', 'electric kettles', 'coffee makers', 'milk frothers', 'blenders', 'juicers', 'hand blenders', 'hand mixers', 'stand mixers'];
  /* Types where accessories only fit the same brand (e.g. Bissell formulas only for Bissell machines) */
  var SAME_BRAND_ONLY = ['vacuum cleaners'];
  var MAX_ITEMS = 8;
  var cache = {};
  var busy = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function search(q) {
    if (cache[q]) return Promise.resolve(cache[q]);
    var url = '/search?view=hoa-recs&type=product&options[unavailable_products]=hide&q=' + encodeURIComponent(q);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { var list = []; try { list = JSON.parse(t.trim()); } catch (e) {} cache[q] = list; return list; })
      .catch(function () { return []; });
  }

  function family(t) { return 'f:' + String(t || '').toLowerCase().split(/\s+/).slice(0, 4).join(' '); }

  function typeQuery(types) {
    return '(' + types.map(function (t) { return 'product_type:"' + t + '"'; }).join(' OR ') + ')';
  }

  function pick(anchor, cartIds, cartFams) {
    var key = (anchor.product_type || '').toLowerCase().trim();
    var types = RULES[key];
    if (!types) return Promise.resolve([]); /* Layer 3: no rule, show nothing */
    var queries = [];
    if (SAME_BRAND_FIRST.indexOf(key) > -1 && anchor.vendor) {
      queries.push('vendor:"' + anchor.vendor + '" AND ' + typeQuery(types));
    }
    if (SAME_BRAND_ONLY.indexOf(key) > -1) {
      if (!anchor.vendor) return Promise.resolve([]);
      queries.push('vendor:"' + anchor.vendor + '" AND ' + typeQuery(types));
    } else {
      queries.push(typeQuery(types));
    }
    return Promise.all(queries.map(search)).then(function (lists) {
      var out = [], seen = {};
      Object.keys(cartFams).forEach(function (f) { seen[f] = 1; });
      lists.forEach(function (list) {
        list.forEach(function (p) {
          if (out.length >= MAX_ITEMS) return;
          if (!p.a || seen[p.id] || cartIds[p.id]) return;
          if (p.p > anchor.final_price) return; /* add-ons only: never pricier than the main item */
          var fam = family(p.t);
          if (seen[fam]) return; /* no two colours of the same model */
          seen[p.id] = 1; seen[fam] = 1; out.push(p);
        });
      });
      return out;
    });
  }

  function render(container, items) {
    var html = '<div class="hoa-recs__head"><p class="hoa-recs__title">You may also like</p>' +
      '<a href="/collections/kitchen-appliances" class="hoa-recs__more">See more &rarr;</a></div><div class="hoa-recs__slider">';
    items.forEach(function (p, i) {
      html += '<div class="hoa-recs__card' + (i === 0 ? ' is-on' : '') + '">' +
        '<a href="' + esc(p.u) + '" class="hoa-recs__img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '">' : '') + '</a>' +
        '<div class="hoa-recs__info"><a href="' + esc(p.u) + '" class="hoa-recs__name">' + esc(p.t) + '</a>' +
        '<span class="hoa-recs__price">' + money(p.p) + '</span>' +
        (p.one
          ? '<button type="button" class="hoa-recs__add" data-hoa-add="' + p.vid + '">Add</button>'
          : '<a href="' + esc(p.u) + '" class="hoa-recs__add">View options</a>') +
        '</div></div>';
    });
    if (items.length > 1) {
      html += '<button type="button" class="hoa-recs__nav hoa-recs__prev" data-hoa-nav="-1" aria-label="Previous">&#8249;</button>' +
        '<button type="button" class="hoa-recs__nav hoa-recs__next" data-hoa-nav="1" aria-label="Next">&#8250;</button>';
    }
    html += '</div>';
    container.innerHTML = html;
  }

  var TRUST_HTML =
    '<div class="hoa-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="m8.5 12 2.5 2.5 4.5-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span><b>Official warranty</b> included</span></div>' +
    '<div class="hoa-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M2.5 10h19M6.5 15h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Pay <b>online by card</b> or <b>cash on delivery</b></span></div>' +
    '<div class="hoa-trust__row"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6h11v10h-11zM13.5 9.5h4l3 3.5V16h-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><circle cx="6.5" cy="17.5" r="1.8" fill="#fff7ed" stroke="currentColor" stroke-width="2"/><circle cx="17" cy="17.5" r="1.8" fill="#fff7ed" stroke="currentColor" stroke-width="2"/></svg><span><b>Delivery all over Lebanon</b> in 2\u20135 days</span></div>';

  function ensureTrust(cart) {
    var list = cart.querySelector('.mini-cart__line-item-list');
    if (!list || cart.querySelector('.hoa-trust')) return;
    var t = document.createElement('div');
    t.className = 'hoa-trust';
    t.innerHTML = '<div class="hoa-trust__box">' + TRUST_HTML + '</div>';
    list.parentNode.insertBefore(t, list.nextSibling);
  }


  function enhance(cart) {
    var content = cart.querySelector('.mini-cart__content');
    if (!content || !cart.querySelector('.mini-cart__line-item-list')) return;
    var count = 0;
    Array.prototype.forEach.call(cart.querySelectorAll('.mini-cart__line-item .quantity-selector__value'), function (inp) { count += parseInt(inp.value, 10) || 0; });
    if (!count) count = parseInt(cart.getAttribute('data-item-count'), 10) || cart.querySelectorAll('.mini-cart__line-item').length;
    if (!cart.querySelector('.hoa-cart-head')) {
      var h = document.createElement('div');
      h.className = 'hoa-cart-head';
      h.textContent = 'Shopping Cart • ' + count;
      content.insertBefore(h, content.firstChild);
    }
    Array.prototype.forEach.call(cart.querySelectorAll('.mini-cart__price-list'), function (pl) {
      if (pl.querySelector('.hoa-save')) return;
      var now = pl.querySelector('.price--highlight'), was = pl.querySelector('.price--compare');
      if (!now || !was) return;
      var n = parseFloat(now.textContent.replace(/[^0-9.]/g, '')), w = parseFloat(was.textContent.replace(/[^0-9.]/g, ''));
      if (!(w > n)) return;
      var sv = document.createElement('span');
      sv.className = 'hoa-save';
      sv.textContent = '(Save $' + (w - n).toFixed(2) + ')';
      pl.appendChild(sv);
    });
    Array.prototype.forEach.call(cart.querySelectorAll('.mini-cart__line-item'), function (li) {
      if (li.getAttribute('data-hoa')) return;
      li.setAttribute('data-hoa', '1');
      var qty = li.querySelector('.mini-cart__quantity'), pl = li.querySelector('.mini-cart__price-list'), rm = li.querySelector('.mini-cart__quantity-remove');
      if (qty && pl) qty.appendChild(pl);
      if (rm) {
        rm.classList.add('hoa-trash');
        rm.setAttribute('aria-label', 'Remove');
        rm.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        li.appendChild(rm);
      }
    });
    var btn = cart.querySelector('button[name="checkout"]');
    var lines = cart.querySelectorAll('.mini-cart__recap-price-line');
    if (btn && lines.length && !btn.getAttribute('data-hoa')) {
      var spans = lines[lines.length - 1].querySelectorAll('span');
      var total = spans.length ? spans[spans.length - 1].textContent.replace(/\s*USD\s*/i, '').trim() : '';
      btn.setAttribute('data-hoa', '1');
      if (total) btn.textContent = 'Checkout • ' + total;
    }
  }

  function fill() {
    var cart = document.getElementById('mini-cart');
    if (!cart) return;
    enhance(cart);
    ensureTrust(cart);
    if (busy) return;
    var list = cart.querySelector('.mini-cart__line-item-list');
    var trustEl = cart.querySelector('.hoa-trust');
    if (!list || !trustEl || trustEl.getAttribute('data-recs') === '1') return; /* run once per drawer render, even when nothing matches */
    trustEl.setAttribute('data-recs', '1');
    var box = document.createElement('div');
    box.className = 'hoa-recs';
    var anchorEl = cart.querySelector('.hoa-trust') || list;
    anchorEl.parentNode.insertBefore(box, anchorEl.nextSibling);
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c.items || !c.items.length) return [];
        var ids = {}, fams = {}, anchor = c.items[0];
        c.items.forEach(function (i) { ids[i.product_id] = 1; fams[family(i.product_title)] = 1; if (i.final_price > anchor.final_price) anchor = i; });
        return pick(anchor, ids, fams);
      })
      .then(function (items) { if (items.length) render(box, items); else box.remove(); })
      .catch(function () { box.remove(); })
      .then(function () {
        busy = false;
        if (!document.body.contains(trustEl)) fill(); /* drawer was redrawn while loading: run again on the new one */
      });
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-hoa-nav]');
    if (nav) {
      e.preventDefault();
      var cards = nav.parentNode.querySelectorAll('.hoa-recs__card'), cur = 0;
      Array.prototype.forEach.call(cards, function (c, i) { if (c.classList.contains('is-on')) cur = i; c.classList.remove('is-on'); });
      cards[(cur + parseInt(nav.getAttribute('data-hoa-nav'), 10) + cards.length) % cards.length].classList.add('is-on');
      return;
    }
    var btn = e.target.closest('[data-hoa-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-hoa-add'), 10), quantity: 1 })
    }).then(function () {
      document.body.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }).catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
  });

  function watch() {
    var cart = document.getElementById('mini-cart');
    if (!cart) return;
    new MutationObserver(function () { fill(); }).observe(cart, { childList: true, subtree: true });
    fill();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
